export interface StockItemAmendment {
  stockNo: string;
  batchNo: string;
  externalNo: string;
  qtyIn: number;
  warehouseId: string;
  locationId: string;
  balance: number;
  supplierDeliveryNoteNo: string;
}
